import { Button } from "@/components/button";

type ReviewFooterProps = {
  /** False while the brief is missing a required criterion. */
  canSubmit?: boolean;
  isSubmitting?: boolean;
  /** Submit waits for in-flight uploads so none is lost. */
  isUploading?: boolean;
  onBackToChat?: () => void;
  onSubmit?: () => void;
};

export function ReviewFooter({
  canSubmit = false,
  isSubmitting = false,
  isUploading = false,
  onBackToChat,
  onSubmit,
}: ReviewFooterProps) {
  return (
    <footer className="sticky bottom-0 z-10 flex h-[76px] shrink-0 items-center justify-end border-t border-border-secondary bg-bg-primary px-4xl">
      <div className="flex items-center gap-3">
        {isUploading ? (
          <span className="text-sm text-text-tertiary">
            Wait for uploads to finish
          </span>
        ) : null}
        {onBackToChat ? (
          <Button
            color="gray"
            onPress={onBackToChat}
            size="lg"
            variant="tertiary"
          >
            Back to chat
          </Button>
        ) : null}
        <Button
          className="px-7"
          isDisabled={!canSubmit || isSubmitting || isUploading}
          onPress={onSubmit}
          size="lg"
          variant="primary"
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </footer>
  );
}
